import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api({
          url: SummaryApi.homeCategoryPreview.url,
          method: SummaryApi.homeCategoryPreview.method,
        });

        const data = res?.data?.data || [];
        const unique = [...new Set(data.map(item => item.category))];
        setCategories(unique);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <footer className="bg-black text-white pt-16 pb-6 px-4 md:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto">

        {/* TOP GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

          {/* COLUMN 1 */}
          <div>
            <h2 className="text-xl font-times mb-4 border-b border-gray-800 pb-2 inline-block">KL PROPERTY</h2>
            <p className="text-[#FFFFFFCC] text-sm leading-relaxed mb-6">
              Sustainable land experts rooted in the heritage of Idukki.
              Specialized in plantation properties and premium residential lands.
            </p>

            <div className="flex gap-4">
              <a href="https://www.instagram.com/kl_property_rajkumar?igsh=MTRndWI5N2ozajF3OQ==" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-500 p-2 rounded-full hover:scale-110 transition">
                <FaInstagram size={16} />
              </a>
              <a href="https://youtube.com/@klpropertytamil?si=cZNZsRC_y7TPUR0e" target="_blank" rel="noopener noreferrer" className="bg-red-600 p-2 rounded-full hover:scale-110 transition">
                <FaYoutube size={16} />
              </a>
              <a href="https://www.facebook.com/share/1GQwSsx46i/" target="_blank" rel="noopener noreferrer" className="bg-blue-600 p-2 rounded-full hover:scale-110 transition">
                <FaFacebook size={16} />
              </a>
            </div>
          </div>

          {/* COLUMN 2 */}
          <div>
            <h3 className="font-semibold font-times mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/" className="hover:text-white text-[#FFFFFFCC] transition">Home</Link></li>
              <li><Link to="/properties" className="hover:text-white text-[#FFFFFFCC] transition">Properties</Link></li>
              <li><Link to="/about-us" className="hover:text-white text-[#FFFFFFCC] transition">About Us</Link></li>
              <li><Link to="/testimonials" className="hover:text-white text-[#FFFFFFCC] transition">Testimonials</Link></li>
              <li><Link to="/gallery" className="hover:text-white text-[#FFFFFFCC] transition">Gallery</Link></li>
              <li><Link to="/contact-us" className="hover:text-white text-[#FFFFFFCC] transition">Contact Us</Link></li>
            </ul>
          </div>

          {/* COLUMN 3 */}
          <div>
            <h3 className="font-semibold font-times mb-4">Property Types</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              {categories.slice(0, 5).map((cat, index) => (
                <li key={index}>
                  <Link to={`/properties?category=${cat.replace(/\s+/g, "-")}`} className="hover:text-white text-[#FFFFFFCC] transition capitalize">
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* COLUMN 4 */}
          <div>
            <h3 className="font-semibold font-times mb-4">Get In Touch</h3>
            <div className="space-y-4 text-[#FFFFFFCC] text-sm">
              <div className="flex items-center gap-3">
                <MapPin size={20} className="text-white mt-1 flex-shrink-0" />
                <a href="https://www.google.com/maps?q=Anakkara+Village+Idukki" target="_blank" rel="noopener noreferrer" className="hover:text-white leading-6">
                  KL Property, Thakidiyel House, Nettithozhu, Anakkara Village, Idukki - 685551
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={20} className="text-white flex-shrink-0" />
                <a href="tel:+918946059070" className="hover:text-white">+91 89460 59070</a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={20} className="text-white flex-shrink-0" />
                <a href="mailto:klproperity@gmail.com" className="hover:text-white">klproperity@gmail.com</a>
              </div>
            </div>
          </div>

        </div>

        {/* DIVIDER */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* BOTTOM SECTION */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[#F7F4EE80] text-xs">
          
          {/* Copyright & Developer */}
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} KL Property. All Rights Reserved. | Developed by <a href="https://www.digida.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white font-bold transition">Digida</a>
          </p>

          {/* Navigation Links for Privacy and Terms */}
          <div className="flex gap-6">
            <Link to="/policy/privacy-policy" className="hover:text-white transition">
              Privacy Policy
            </Link>
            <Link to="/policy/terms-conditions" className="hover:text-white transition">
              Terms & Conditions
            </Link>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;